import { useEffect, useState } from "react";
import * as Yup from "yup";
import Api from "../../Api";
import { ListStates, NewStateModalForm } from "../../component";
import { toast } from "react-toastify";

const States = ()=>{
  interface State {
    stateId: number;
    stateName: string;
  }
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [listCount, setListCount] = useState(3);
    const [states, setStates] = useState<State[]>([])

    const api = Api();

    const onChangePageIndex = (pageNumber: number) => setPageIndex((pageNumber - 1));
    const onChangePageSize = (pageSize: number) => setPageSize((pageSize));
    const [selectedRecord, setSelectedRecord] = useState({stateId: 0, stateName: ""});
    const [isEdit, setIsEdit] = useState(false);

    const StateValidationSchema = Yup.object().shape({
        stateName: Yup.string().required("State Name is required"),
      });

      const handleCreateState = (stateDetails: any) => {
        if(isEdit){
          api.state.updateState(stateDetails).then((response: any) => {
            toast.success(response.message);
            setIsEdit(false)
            getStates();
          });
        }else{
          api.state.createState(stateDetails).then((response: any) => {
            toast.success(response.message);
            getStates();
          });
        }
        

      };

      const getStates = ()=>{
        api.state.getStates().then((response: any)=>{
          if(response){
            setStates([...response.states])
          }
         
        })
      }

      const onCloseHandler=()=>{
        setIsEdit(false)
      }

      const editHandler = (state: any)=>{
        setSelectedRecord({
          stateId: state.stateId,
          stateName: state.stateName,
        });
        setIsEdit(true)
      }

      useEffect(()=>{
        getStates()
      }, [])

    return(
        <div className="w-100 p-2">
         <div className="float-end">
         <NewStateModalForm
          StateValidationSchema={StateValidationSchema}
          onCreateNewState={handleCreateState}
          stateData={selectedRecord}
          isEdit={isEdit}
          onClose={()=>onCloseHandler()}
        />
         </div>
         
        <ListStates
          statesList={states}
          totalItemCount={listCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          onChangePageIndex={(pageNumber:number) => onChangePageIndex(pageNumber)}
          onChangePageSize={(pageSize:number) => onChangePageSize(pageSize)}
          handelDelete={()=>{}}
          handelEdit={(state)=>editHandler(state)}
        />
        </div>
    )
}

export default States;